import { FormControl } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import HostfullyIcon from 'assets/images/icons/channels/hostfully.svg?react';
import { GenericFormFieldBaseProps } from 'components/forms/genericFormField/GenericFormField.types';
import RadioGroupField from 'components/forms/radioGroupField/RadioGroupField';
import {
  RadioIconsContainer,
  RadioOptionsContainer,
} from './PropertyFeeModal.styles';
import useFormData from './useFormData';

interface IsOptionalFieldProps {
  labelInputSizes: Pick<GenericFormFieldBaseProps, 'colSmInput' | 'colSmLabel'>;
}

const IsOptionalField = ({ labelInputSizes }: IsOptionalFieldProps) => {
  const { setValue } = useFormContext();
  const { t } = useTranslation();
  const { isAppliedToHostfully, isRollInFeeIntoRent, isTypeTax } =
    useFormData();

  const isHidden = isTypeTax || !isAppliedToHostfully || isRollInFeeIntoRent;

  const onChangeHandler = (e: React.FormEvent<FormControl>) => {
    if ((e.target as HTMLInputElement).value === 'YES') {
      setValue('appliesToHostfully', 'YES');
      setValue('rollsIntoRent', 'NO');
    }
  };

  if (isHidden) {
    return null;
  }

  return (
    <RadioOptionsContainer className="has-right-tooltip">
      <RadioGroupField
        horizontal
        name="optional"
        label={t(
          'pageProperty.feesTaxesAndPolicies.propertyFeesAndTaxes.addModal.feeIsOptional',
        )}
        onChangeHandler={onChangeHandler}
        rightTooltip={t(
          'pageProperty.feesTaxesAndPolicies.propertyFeesAndTaxes.addModal.feeOptionalTooltip',
        )}
        options={[
          { value: 'NO', label: t('common.no') },
          { value: 'YES', label: t('common.yes') },
        ]}
        {...labelInputSizes}
      />
      <RadioIconsContainer>
        <HostfullyIcon />
      </RadioIconsContainer>
    </RadioOptionsContainer>
  );
};

export default IsOptionalField;
